import React, {Fragment, useMemo, useState} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from 'react-redux';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {GUTTER_MD, MODAL_WIDTH_LG, SPAN_HALF} from "../../../../../styles/constants";
import {Button, Col, Input, Row, Select} from "antd";
import Call from "../../../../../hocs/call";
import {capitalize} from "lodash";
import {componentHasCodelist} from "../utils";
import {getDataFromCodelist, hideTranscodingSettings} from "../../transcoding/actions";
import {getArtefactTripletFromUrn} from "../../../../../utils/sdmxJson";

const mapStateToProps = ({app, scenes: {mappingHandler: {mappingSet: {wizard, transcoding}}}}) => ({
    appLanguage: app.language,
    selectedDsdColumnName: wizard.selectedDsdColumnName,
    dsd: wizard.dsd,
    columnCodelist: transcoding.columnCodelist,
});

const mapDispatchToProps = dispatch => ({
    onGetDataFromCodelist: (codelistTriplet) => dispatch(getDataFromCodelist(codelistTriplet)),
    onHideTranscodingSettings: () => dispatch(hideTranscodingSettings()),
});


const Transcoding01Alert = ({
                                 t,
                                 showTranscodingSettings,
                                 onHideTranscodingSettings,
                                onHideTranscodingSettingsState,
                                 onGetDataFromCodelist,
                                 callback,
                                 selectedDsdColumnName,
                                 dsd,
                                 columnCodelist,
                                 appLanguage,
                             }) => {
    const [simpleValue, setSimpleValue] = useState(null);
    const dsdInfo = useMemo(() => {
        if (!showTranscodingSettings || !selectedDsdColumnName || !dsd) {
            return null;
        }
        return dsd.find(item => item.id === selectedDsdColumnName);
    }, [selectedDsdColumnName, dsd, showTranscodingSettings]);
    const hasCodelist = useMemo(() => dsdInfo ? componentHasCodelist(dsdInfo) : false, [dsdInfo])
    const codelistTriplet = useMemo(() => hasCodelist ? getArtefactTripletFromUrn(dsdInfo.localRepresentation.enumeration) : null, [dsdInfo, hasCodelist])

    return (
        <Fragment>
            <Call cb={onGetDataFromCodelist}
                  cbParam={codelistTriplet}
                  disabled={!codelistTriplet || !!columnCodelist}
            >
                <EnhancedModal
                    title={`Transcoding Settings for ${selectedDsdColumnName} 0:1 mapping`}
                    visible={showTranscodingSettings}
                    width={MODAL_WIDTH_LG}
                    withDataLanguageSelector
                    onCancel={() => {
                        setSimpleValue(null);
                        onHideTranscodingSettings();
                        onHideTranscodingSettingsState();
                    }}
                    footer={
                        <Fragment>
                            <Button
                                onClick={() => {
                                    setSimpleValue(null);
                                    onHideTranscodingSettings();
                                    onHideTranscodingSettingsState();
                                }}
                            >
                                {t('commons.buttons.close.title')}
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => {
                                    if (callback) callback(simpleValue);
                                    setSimpleValue(null);
                                    onHideTranscodingSettings();
                                    onHideTranscodingSettingsState();
                                }}
                            >
                                {t('commons.buttons.save.title')}
                            </Button>
                        </Fragment>
                    }
                >
                    <Row type="flex" gutter={GUTTER_MD}>
                        <Col span={SPAN_HALF}>
                            {t("scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.constantValueField")}:
                        </Col>
                        <Col span={SPAN_HALF}>
                            {hasCodelist && <Select
                                value={simpleValue}
                                style={{width: "100%"}}
                                showSearch
                                filterOption={(inputValue, {props}) =>
                                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                onSelect={(value) => setSimpleValue(value)}
                            >
                                {(columnCodelist || []).map(value =>
                                    <Select.Option
                                        key={value.Code}
                                        value={value.Code}
                                        title={`${value.Code} - ${value[`Name${capitalize(appLanguage)}`] ? value[`Name${capitalize(appLanguage)}`] : value["NameEn"]}`}
                                    >
                                        {value.Code} - {value[`Name${capitalize(appLanguage)}`] ? value[`Name${capitalize(appLanguage)}`] : value["NameEn"]}
                                    </Select.Option>
                                )}
                            </Select>}
                            {!hasCodelist &&
                                <Input value={simpleValue} style={{width: "100%"}} onChange={e => setSimpleValue(e.target.value)}/>}
                        </Col>
                    </Row>
                </EnhancedModal>
            </Call>
        </Fragment>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(Transcoding01Alert);